<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title class="custom-title"> {{ 'enquetes' | nomenclatura | async }} </ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>
  <div class="alinhamento-itens">
    <p class="nome-enquete border-bottom">{{descricao}}</p>

    <div class="remove-border border-bottom">
      <div class="pergunta-enquete-list">
        <div *ngIf="pergunta.tipo == 1">
          <div>
            <p style="margin-bottom: 1.2rem">{{pergunta.pergunta}}</p>

            <ion-radio-group [(ngModel)]="alternativaRadio" class="radio">
              <ion-item *ngFor="let alternativa of pergunta.alternativas">
                <ion-radio
                  aria-hidden="true"
                  slot="start"
                  [value]="alternativa.id"
                  [disabled]="disableBotoes"
                ></ion-radio>

                <ion-label [ngClass]="{'selected': alternativa.id === alternativaRadio}">
                  {{alternativa.alternativa}}
                </ion-label>

                <ion-thumbnail *ngIf="alternativa.image" slot="end">
                  <img [src]="alternativa.image | image:' '" />
                </ion-thumbnail>
              </ion-item>
            </ion-radio-group>
          </div>
        </div>

        <div *ngIf="pergunta.tipo == 2" class="remove-border">
          <p *ngIf="!pergunta.limite" class="detalhes">
            {{'Selecione uma ou mais alternativas e clique em ' + nomenclaturaBotaoProximo | translate}}
          </p>

          <p *ngIf="pergunta.limite && pergunta.limite > 0" class="detalhes">
            {{'Selecione até' | translate}} <strong>{{pergunta.limite}}</strong> {{'alternativas e clique em' | translate }}
            {{nomenclaturaBotaoProximo}}
          </p>

          <p style="margin-bottom: 1.2rem">{{pergunta.pergunta}}</p>

          <ion-radio-group [(ngModel)]="alternativaRadio" class="radio">
            <ion-item *ngFor="let alternativa of pergunta.alternativas" (click)="changeCheck(alternativa);">
              <ion-checkbox
                [disabled]="disableBotoes || ((pergunta.limite && pergunta.limite > 0) && alternativasCheck.length >= pergunta.limite && !alternativa.checked)"
                [checked]="alternativa.checked"
              ></ion-checkbox>

              <ion-label style="margin-left: 8px"> {{alternativa.alternativa}} </ion-label>

              <ion-thumbnail *ngIf="alternativa.image" slot="end">
                <img [src]="alternativa.image | image:' '" />
              </ion-thumbnail>
            </ion-item>
          </ion-radio-group>
        </div>

        <div *ngIf="pergunta.tipo == 3" class="remove-border">
          <div>
            <p>{{pergunta.pergunta}}</p>
            <p class="informacao-resposta">{{'Informe Sua Resposta' | translate}}:</p>

            <ion-list class="add-border-list">
              <ion-textarea
                [disabled]="disableBotoes"
                class="custom-textarea"
                placeholder="{{'Digite aqui' | translate}}"
                [(ngModel)]="alternativaTexto"
              ></ion-textarea>
            </ion-list>
          </div>
        </div>
      </div>
    </div>

    <div class="ion-margin-top">
      <ion-row *ngIf="pergunta.obrigatorio == 0">
        <ion-col>
          <ion-button [disabled]="disableBotoes" expand="block" (click)="pular()" class="btn-default btn-height">
            {{'Pular Pergunta' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="6">
          <ion-button
            [disabled]="primeira || disableBotoes"
            expand="block"
            fill="outline"
            class="btn-custom-icon btn-height exit"
            (click)="voltar()"
          >
            <i class="fas fa-long-arrow-left"></i>

            {{'Voltar' | translate}}
          </ion-button>
        </ion-col>

        <ion-col size="6">
          <ion-button
            [disabled]="
            (pergunta.tipo == 1 && !alternativaRadio) || 
            (pergunta.tipo == 2 && !alternativasCheck.length) || 
            (pergunta.tipo == 3 && !alternativaTexto?.trim()) || 
            disableBotoes"
            expand="block"
            class="btn-custom-icon btn-height"
            (click)="responderPergunta()"
            *ngIf="pergunta.ordem === perguntasLength.length"
          >
            {{'Enviar' | translate}}

            <i class="fas fa-long-arrow-right"></i>
          </ion-button>

          <ion-button
            [disabled]="
          (pergunta.tipo == 1 && !alternativaRadio) || 
          (pergunta.tipo == 2 && !alternativasCheck.length) || 
          (pergunta.tipo == 3 && !alternativaTexto?.trim()) || 
          disableBotoes"
            expand="block"
            class="btn-custom-icon btn-height"
            (click)="responderPergunta()"
            *ngIf="pergunta.ordem !== perguntasLength.length"
          >
            {{nomenclaturaBotaoProximo | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </div>

    <div class="footer">
      <ion-progress-bar class="barra-progresso" [value]="perguntaNumeroExibida / totalExibido"></ion-progress-bar>

      <p class="pergunta-enquete">{{ 'Pergunta' | translate }} {{ ordemStatus }}</p>
    </div>
  </div>
</ion-content>
